// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1Dfif","inner":"Form_inner__1zBDV","range":"Form_range__XEREK","name":"Form_name__1T063","actions":"Form_actions__33dHr"};